const cms = document.querySelector("#cms");
const triggerStats = cms?.querySelectorAll("[data-trigger]");
const statsLineCMS = cms?.querySelectorAll("[data-stats-line]");

let statsCMS1, statsCMS2, statsCMS3, statsCMS4;

const statsCmsArray = {
  woocommerce: {
    stats1: 77,
    stats2: 302,
    stats3: 284,
    stats4: 111,
  },
  prestashop: {
    stats1: 78,
    stats2: 305,
    stats3: 283,
    stats4: 112,
  },
  shoper: {
    stats1: 77,
    stats2: 303,
    stats3: 287,
    stats4: 113,
  },
  magneto: {
    stats1: 79,
    stats2: 306,
    stats3: 287,
    stats4: 114,
  },
};

const optionsCMS = {
  startVal: 0.0,
  decimalPlaces: 0,
  useGrouping: false,
  separator: "",
};

const markSelectCMS = (clickCMS) => {
  triggerStats.forEach((triggerItem) => {
    triggerItem.classList.remove("active");
  });
  clickCMS.classList.add("active");
};

const updateMarkCMS = (clickCMS) => {
  statsCMS1.update(statsCmsArray[clickCMS]["stats1"]);
  statsCMS2.update(statsCmsArray[clickCMS]["stats2"]);
  statsCMS3.update(statsCmsArray[clickCMS]["stats3"]);
  statsCMS4.update(statsCmsArray[clickCMS]["stats4"]);

  statsLineCMS[0].setAttribute(
    "style",
    `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
      statsCmsArray[clickCMS]["stats1"] / 2
    }%, rgba(224, 215, 213, 1) ${statsCmsArray[clickCMS]["stats1"] / 2}%)`
  );
  statsLineCMS[1].setAttribute(
    "style",
    `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
      statsCmsArray[clickCMS]["stats2"] / 2
    }%, rgba(224, 215, 213, 1) ${statsCmsArray[clickCMS]["stats2"] / 2}%)`
  );
  statsLineCMS[2].setAttribute(
    "style",
    `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
      statsCmsArray[clickCMS]["stats3"] / 2
    }%, rgba(224, 215, 213, 1) ${statsCmsArray[clickCMS]["stats3"] / 2}%)`
  );
  statsLineCMS[3].setAttribute(
    "style",
    `background .5s; background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
      statsCmsArray[clickCMS]["stats4"] / 1.2
    }%, rgba(224, 215, 213, 1) ${statsCmsArray[clickCMS]["stats4"] / 1.2}%)`
  );
};

const updateCMSStats = (clickCMS) => {
  clickCMS === "woocommerce" ? updateMarkCMS(clickCMS) : null;
  clickCMS === "prestashop" ? updateMarkCMS(clickCMS) : null;
  clickCMS === "shoper" ? updateMarkCMS(clickCMS) : null;
  clickCMS === "magneto" ? updateMarkCMS(clickCMS) : null;
};

const updateStats = (event) => {
  const clickCMS = event.currentTarget;
  markSelectCMS(clickCMS);
  updateCMSStats(clickCMS.dataset.trigger);
};

const initializeCMSCountUp = () => {
  statsCMS1 = new CountUp("stats-cms-1", statsCmsArray.woocommerce.stats1, optionsCMS);
  statsCMS2 = new CountUp("stats-cms-2", statsCmsArray.woocommerce.stats2, optionsCMS);
  statsCMS3 = new CountUp("stats-cms-3", statsCmsArray.woocommerce.stats3, optionsCMS);
  statsCMS4 = new CountUp("stats-cms-4", statsCmsArray.woocommerce.stats4, optionsCMS);
};

const checkElementVisibilityCMS = () => {
  const element = document.getElementById("countBoxCMS");
  if (element && isElementInViewportCMS(element)) {
    statsCMS1.start();
    statsCMS2.start();
    statsCMS3.start();
    statsCMS4.start();

    statsLineCMS[0].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
        statsCmsArray.woocommerce.stats1 / 2
      }%, rgba(224, 215, 213, 1) ${statsCmsArray.woocommerce.stats1 / 2}%)`
    );
    statsLineCMS[1].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
        statsCmsArray.woocommerce.stats2 / 2
      }%, rgba(224, 215, 213, 1) ${statsCmsArray.woocommerce.stats2 / 2}%)`
    );
    statsLineCMS[2].setAttribute(
      "style",
      `background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
        statsCmsArray.woocommerce.stats3 / 2
      }%, rgba(224, 215, 213, 1) ${statsCmsArray.woocommerce.stats3 / 2}%)`
    );
    statsLineCMS[3].setAttribute(
      "style",
      `background .5s; background: linear-gradient(90deg, rgba(242, 242, 244, 1) 0%, rgba(239,84,48,1) ${
        statsCmsArray.woocommerce.stats4 / 1
      }%, rgba(224, 215, 213, 1) ${statsCmsArray.woocommerce.stats4 / 1}%)`
    );

    window.removeEventListener("scroll", checkElementVisibilityCMS);
  }
};

function isElementInViewportCMS(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return rect.top < windowHeight && rect.bottom > 0 && rect.left < windowWidth && rect.right > 0;
}

const setListeners = () => {
  triggerStats.forEach((trigger) => {
    trigger.addEventListener("click", (event) => updateStats(event));
    trigger.addEventListener("touchstart", (event) => updateStats(event));
  });
};

const initCMSSection = () => {
  if (cms) {
    setListeners();
    initializeCMSCountUp();
    checkElementVisibilityCMS();
    window.addEventListener("scroll", checkElementVisibilityCMS);
  }
};

initCMSSection();
